var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "myskov-orders" },
    [
      _c("div", { staticClass: "myskov-orders__header" }, [
        _c("h2", { domProps: { textContent: _vm._s(_vm.translations.title) } }),
        _vm._v(" "),
        _c("p", {
          domProps: { innerHTML: _vm._s(_vm.translations.description) }
        })
      ]),
      _vm._v(" "),
      !_vm.loadingOrders && !_vm.orders.length
        ? _c(
            "msg-block",
            { attrs: { type: "warning" } },
            [
              _c("p", [
                _c("b", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.no_orders_title)
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.translations.no_orders_message)
                }
              }),
              _vm._v(" "),
              _c("router-link", {
                attrs: { to: "/" },
                domProps: {
                  textContent: _vm._s(_vm.translations.start_search_txt)
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loadingOrders
        ? _c("msg-block", [
            _c("p", [
              _c("b", {
                domProps: { textContent: _vm._s(_vm.translations.loading) }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loadingOrdersErr
        ? _c("msg-block", { attrs: { type: "error" } }, [
            _c("p", [
              _c("b", {
                domProps: { textContent: _vm._s(_vm.loadingOrdersErr) }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.orders, function(order, orderKey) {
        return _c("order", { key: orderKey, attrs: { order: order } })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c86e3e0c", { render: render, staticRenderFns: staticRenderFns })
  }
}